export default __webpack_public_path__ + "static/media/logo-born.762ea3ed.png";